import styled from 'styled-components';

export const StyledWrapper = styled.div<{ mb?: number; error: boolean }>`
    label {
        font-weight: 700;
    }
  
    ${({ mb }) => `margin-bottom: ${mb}px`};

    //TODO: rm after bgc issue for <Input /> component will be fixed
    input {
      ${({ theme, error }) => error && `background-color: ${theme['surface-default']};`};}
    }

    //TODO: rm after padding issue in lib will be fixed
    > * {
        margin-bottom: 20px;
    }
`;
